import { Dimensions,} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const isSmallDevice = Dimensions.get("window").width < 767;

const useStyles = CreateResponsiveStyle(
  {
    mainContainerStyle: {
      height: Dimensions.get("window").height,
      width: "100%",
    },
    viewStyle: {
      width: 349.9,
      borderRadius: 15,
      backgroundColor: "#ffffff",
      alignItems: "center",
      justifyContent: "center",
      top: "-10%",
    },
    bodyContainerStyle: {
      flexDirection: "row",
      width: "100%",
      height: "auto",
      flexWrap: "wrap",
    },
    logoWidget:{flexDirection:"row",justifyContent: "space-between",marginTop: 20,marginBottom: 10,},
    widgetCenter:{alignSelf:"center",justifyContent: "center",alignContent: "center",},

    bodyLeftViewStyle: {
      backgroundColor: "#f3f3f3",
      flex: 0.4,
      alignItems: "center",
      justifyContent: "center",
      paddingVertical: 25,
    },
    contentR:{ alignItems: "center",  marginTop: isSmallDevice ? 20 : "15%", width: "100%"},
    submitBtnWrapper:{ marginTop: "5%", width: 108, height: 37 },
    btnWidget:{marginTop:25,width: 108,height: 37,alignSelf: "center",},
    reloadCaptcha:{ width: "20%", height: 40, justifyContent: "center",},
    captchaInputWidget:{width:"60%",flexDirection: "row",backgroundColor: "#f3f3f3",alignItems: "center",justifyContent: "center",borderTopRightRadius: 10,borderBottomRightRadius: 10,justifyContent: "center",},
    captchaTextWrapper:{alignItems:"center",width: "40%",borderRightWidth: 1,borderRightColor: "#cccccc",justifyContent: "center",},
    mobileComponentStyle:{position:"absolute",zIndex: 99,right: 15,left: 0,display: "none",},
    captchaWrapper:{flexDirection:"row",width: "80%",height: 40,borderRadius: 10,borderWidth: 1,marginTop: 30,borderColor: "#cccccc",},
    containerBox: {
      width: 350,
      height: 360,
      borderRadius: 15,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
    },

    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: 10,
      marginTop: 5,
    },

    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bd2d37",
    },

    rectangle41: {
      width: "100%",
      height: 55,
      backgroundImage: "linear-gradient(to right, #f2717b 0%, #9d1d27 100%)",
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
    },

    textInputStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 40,
      letterSpacing: 7.5,
      textAlign: "center",
      color: "#02122c",
    },
    labelStyle: {
      fontFamily: "Inter",
      fontSize: 8,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 10,
      letterSpacing: 0,
      textAlign: "left",
      color: "blue",
      position: "absolute",
      zIndex: 999,
      top: -5,
      left: 10,
      backgroundColor: "white",
      paddingHorizontal: 3,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 13,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
    },
    captchaInputStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 8.4,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      alignSelf: "center",
      width: "100%",
      height: "100%",
      textAlign: "center",
    },
  },

  {
    [DEVICE_SIZES.LG]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },

      viewStyle: {
        width: 349.9,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        alignItems: "center",
        justifyContent: "center",
        top: "-10%",
      },

      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3.2,
        flexWrap: "wrap",
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.4,
        alignItems: "center",
        justifyContent: "center",
      },

      viewStyle1: {
        paddingTop: "10%",
        flexWrap: "wrap",
      },
      footerFirstViewStyle: {
        backgroundColor: "#ffffff",
        flex: 0.4,
        marginTop: "5%",
      },
      footerSecondViewStyle: {
        backgroundColor: "#9d1d27",
        flex: 0.6,
        paddingTop: "5%",
      },

      downloadAppTextStyle: {
        fontFamily: "Inter",
        fontSize: 7,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 7,
        letterSpacing: 0,
        textAlign: "right",
        color: "#54565b",
        paddingRight: 5,
      },

      mobileComponentStyle: {
        display: "none",
      },
      rightViewStyle: {
        display: "flex",
      },
    },
    [DEVICE_SIZES.MD]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      tabPlaystoreViewStyle: {
        display: "flex",
      },
      idfcTextStyle: {
        fontSize: 55,
      },
      qrViewStyle: {
        display: "none",
      },

      viewStyle: {
        width: 349.9,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        alignItems: "center",
        justifyContent: "center",
        top: "-10%",
        display: "none",
      },

      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
        marginTop: -20,
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.5,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      },

      ffBenefitsTextStyle: {
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 22.2,
        letterSpacing: 0,
        textAlign: "left",
        color: "#ffffff",
        paddingLeft: "10%",
      },
      benefitsDescTextStyle: {
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: "100",
        fontStyle: "normal",
        lineHeight: 14,
        letterSpacing: 0.2,
        textAlign: "left",
        color: "#ffffff",
        paddingLeft: "10%",
        paddingTop: 10,
      },
      headerImageViewStyle: {
        flex: Dimensions.get("window").width < 800 ? 0.6 : 0.7,
      },

      footerFirstViewStyle: {
        backgroundColor: "#ffffff",
        flex: 0.5,
        marginTop: "5%",
      },
      footerSecondViewStyle: {
        backgroundColor: "#9d1d27",
        flex: 0.5,
        paddingTop: "5%",
      },

      mobileComponentStyle: {
        display: "none",
      },
      rightViewStyle: {
        display: "flex",
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      viewStyle: {
        width: 349.9,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        alignItems: "center",
        justifyContent: "center",
        top: "-10%",
        display: "none",
      },

      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
        backgroundColor: "red",
        marginTop: -20,
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.5,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      },

      mobileComponentStyle: {
        display: "none",
      },
      rightViewStyle: {
        display: "flex",
      },
      firstForwardViewStyle: {
        display: "flex",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainerStyle: {
        height: 1100,
        minHeight: 850,
        maxHeight: 1100,
        width: "100%",
      },
      viewStyle: {
        width: 349.9,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        alignItems: "center",
        justifyContent: "center",
        top: "-10%",
        display: "none",
      },

      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.45,
      },

      ffBenefitsTextStyle: {
        fontFamily: "Inter",
        fontSize: 14,
        lineHeight: 22.2,
        letterSpacing: 0,
        textAlign: "center",
        color: "#ffffff",
        paddingLeft: 0,
      },
      benefitsDescTextStyle: {
        fontFamily: "Inter",
        fontSize: 11,
        fontWeight: "100",
        fontStyle: "normal",
        lineHeight: 14,
        letterSpacing: 0.2,
        textAlign: "center",
        color: "#ffffff",
        paddingLeft: 0,
        paddingTop: 10,
        paddingLeft: 5,
      },
      headerImageViewStyle: {
        flex: 0.6,
        display: "none",
      },
      viewStyle1: {
        paddingTop: 10,
        flexWrap: "wrap",
      },
      mobileComponentStyle: {
        display: "flex",
        backgroundColor: "#f3f3f3",
        width: "100%",
        paddingRight: 12,
      },
      rightViewStyle: {
        display: "none",
      },
      containerBox: {
        width: 330,
        height: 340,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
      },

      rectangle41: {
        width: "100%",
        height: 39,
        borderTopRightRadius: 15,
        borderTopLeftRadius: 15,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
      },
      textInputStyle: {
        fontFamily: "Inter",
        fontSize: 15,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 40,
        letterSpacing: 7.5,
        textAlign: "center",
        color: "#02122c",
      },
      labelStyle: {
        fontFamily: "Inter",
        fontSize: 8,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 10,
        letterSpacing: 0,
        textAlign: "left",
        color: "blue",
        position: "absolute",
        zIndex: 999,
        top: -5,
        left: 10,
        backgroundColor: "white",
        paddingHorizontal: 3,
      },
      textStyle: {
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 13,
        letterSpacing: 0,
        textAlign: "left",
        color: "#999999",
      },
      captchaInputStyle: {
        fontFamily: "Inter",
        fontSize: 11,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 8.4,
        letterSpacing: 0,
        textAlign: "left",
        color: "#999999",
        alignSelf: "center",
        width: "70%",
        height: "100%",
        textAlign: "center",
      },
    },
  }
);

export default useStyles;